import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { CallState } from '@lcs/shared/api';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Detail } from 'src/app/common-components/detail/detail';
import { FormsBase } from 'src/app/common-components/forms-base/forms-base';
import { getExtensionGroupDetailsPrivileges } from 'src/app/privileges/privileges.selector';
import { ExtensionGroupDetailSaveEvent } from '../models/extension-group-detail-form-submit-event';
import { ExtensionGroupDetailView } from '../models/extension-group-detail-view.model';
import { ExtensionGroupPrivileges } from '../models/extension-group-privileges';
import { ExtensionGroupDetailFormService } from '../services/extension-group-detail-form.service';
import * as ExtensionGroupDetailActions from '../state/extension-group-detail.actions';
import { getExtensionGroup, getExtensionGroupCallState } from '../state/extension-group-detail.selectors';
@Component({
    encapsulation: ViewEncapsulation.None,
    host: { class: 'entity-detail' },
    providers: [ExtensionGroupDetailFormService, { provide: FormsBase, useExisting: ExtensionGroupDetailFormService }],
    selector: 'ndt-extension-group-details',
    templateUrl: './extension-group-detail.component.html',
    standalone: false
})
export class ExtensionGroupDetailComponent
   extends Detail<ExtensionGroupDetailFormService>
   implements OnDestroy, OnInit
{
   extensionGroup$: Observable<ExtensionGroupDetailView | null>;

   callState$: Observable<CallState>;

   extensionGroupPrivileges$: Observable<ExtensionGroupPrivileges>;
   constructor(public store: Store, private router: Router, protected formService: ExtensionGroupDetailFormService) {
      super(store, formService);
      this.extensionGroup$ = this.store.pipe(select(getExtensionGroup));
      this.callState$ = this.store.pipe(select(getExtensionGroupCallState));
      this.extensionGroupPrivileges$ = this.store.pipe(select(getExtensionGroupDetailsPrivileges));
      this.store.dispatch(ExtensionGroupDetailActions.extensionGroupDetailLoad());
   }

   ngOnInit(): void {
      this.router.events.pipe(takeUntil(this.destroyed$)).subscribe((e) => {
         if (e instanceof NavigationEnd) {
            this.store.dispatch(ExtensionGroupDetailActions.extensionGroupDetailLoad());
         }
      });
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   onFormSaveCanceled(): void {
      this.store.dispatch(ExtensionGroupDetailActions.extensionGroupDetailCancel());
   }

   onFormSubmitted(event: ExtensionGroupDetailSaveEvent): void {
      this.store.dispatch(ExtensionGroupDetailActions.saveExtensionGroupDetail(event));
   }

   onDeleteExtensionGroup(event: { extensionGroupId: number; name: string }) {
      this.store.dispatch(ExtensionGroupDetailActions.deleteExtensionGroup(event));
   }
}
